import React, { Component } from 'react';
import { db, ref, firebaseStorage } from '../../config/constants.js'
import FileUploader from 'react-firebase-file-uploader';
import { Progress } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class ImageUploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 0,
            isUploading: false,
            fileName: '',
            fileUrl: '',
            actualFileName: '',
        }
    }

    amp_logFileUploadEvent = (event) => {

        let eventProperties = {
            "step":event
        }

    }

    /**
     * HANDLE THE FILE UPLOADING..
     */
    handleUploadStart = (file) => {
        console.log("fx1f ++++++ handle uploadStart file:" + file.name.split('.')[0]);
        this.amp_logFileUploadEvent("start");
        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }


    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("fx1f12 +++++++handleUploadSuccess");
        this.amp_logFileUploadEvent("complete");
        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
       // let orderKey = this.props.fileName;
        firebaseStorage.ref(this.props.storageReference).child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ fileUrl: url })
                console.log("url is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.props.updateWhenFileUploadComplete(true, this.state.actualFileName,url);
            }
        );
    };

    //  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("fx1f13 +++++++: handleUploadError");
        this.amp_logFileUploadEvent("error");
        this.setState({ isUploading: false });
        console.error(error);
    }

    render() {

        const progressBarUI = (this.state.isUploading ? <Progress percent={this.state.progress} progress /> : "")

        return (
            <div>

                <FileUploader
                    //accept="image/*,"
                    accept="*,"
                    name="avatar"
                    filename={this.props.fileName}
                    //storageRef={firebaseStorage.ref('orderDesigns/')}
                    storageRef={firebaseStorage.ref(this.props.storageReference)}
                    onUploadStart={this.handleUploadStart}
                    onUploadSuccess={this.handleUploadSuccess}
                    onProgress={this.handleProgress}
                />

              

                {/* <h4>URL:{this.state.fileUrl}</h4> */}
                {/* <Progress percent={this.state.progress} progress /> */}
                {progressBarUI}
            </div>
        )
    }
}

ImageUploader.propTypes = {
    updateWhenFileUploadComplete: PropTypes.function,
    storageReference: PropTypes.string
  };


// WEBPACK FOOTER //
// ./src/components/newSite/ImageUploader.js